import {
  privateFetch
} from "./fetch";

export const getAnalyticsData = (appId) => {
  const url = `${__BASE_API_URL__}/appAnalytics?appId=${appId}`;

  return new Promise((resolve, reject) => {
    return privateFetch(url)
    .then(resolve)
    .catch(reject);
  });
};